/* Clay Maker Lab — landing behaviour.
   Everything here is progressive enhancement: the gallery scrolls, the FAQ opens and the
   buy form submits with JavaScript disabled. */

(function () {
  'use strict';

  /* ------------------------------------------------------------ hero gallery */

  function initGallery(root) {
    if (root.dataset.cmlReady === 'true') return;
    root.dataset.cmlReady = 'true';

    var slidesEl = root.querySelector('[data-cml-slides]');
    if (!slidesEl) return;

    var slides = Array.prototype.slice.call(slidesEl.children);
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cml-thumb]'));
    var prev = root.querySelector('[data-cml-prev]');
    var next = root.querySelector('[data-cml-next]');
    var index = 0;

    function markCurrent(i) {
      index = i;
      thumbs.forEach(function (thumb, n) {
        thumb.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    }

    function goTo(i) {
      var target = Math.max(0, Math.min(i, slides.length - 1));
      slidesEl.scrollTo({ left: slidesEl.clientWidth * target, behavior: 'smooth' });
      markCurrent(target);
    }

    thumbs.forEach(function (thumb, n) {
      thumb.addEventListener('click', function () {
        goTo(n);
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        goTo(index - 1 < 0 ? slides.length - 1 : index - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        goTo(index + 1 >= slides.length ? 0 : index + 1);
      });
    }

    // Keep the thumbnails in sync when the strip is swiped instead of clicked.
    var scrollTimer = null;
    slidesEl.addEventListener('scroll', function () {
      if (scrollTimer) window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        var width = slidesEl.clientWidth;
        if (width > 0) markCurrent(Math.round(slidesEl.scrollLeft / width));
      }, 90);
    });

    markCurrent(0);
  }

  /* ------------------------------------------------------------- header menu */

  function initHeader(root) {
    if (root.dataset.cmlReady === 'true') return;
    root.dataset.cmlReady = 'true';

    var toggle = root.querySelector('[data-cml-menu-toggle]');
    var drawer = root.querySelector('[data-cml-menu]');
    if (!toggle || !drawer) return;

    toggle.addEventListener('click', function () {
      var open = drawer.getAttribute('data-open') === 'true';
      drawer.setAttribute('data-open', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  /* ----------------------------------------------------------- order bump */

  function initBuyForm(form) {
    if (form.dataset.cmlReady === 'true') return;
    form.dataset.cmlReady = 'true';

    var bump = form.querySelector('[data-cml-bump]');
    var qty = form.querySelector('[data-cml-bump-qty]');
    if (!bump || !qty) return;

    function sync() {
      qty.disabled = !bump.checked;
    }

    bump.addEventListener('change', sync);
    sync();
  }

  /* --------------------------------------------------------------- marquee */

  // Duration scales with the ribbon's width so the speed stays constant on every screen.
  function initMarquee(root) {
    var track = root.querySelector('[data-cml-marquee-track]');
    if (!track) return;

    var pxPerSecond = parseFloat(root.dataset.cmlSpeed || '60');
    var half = track.scrollWidth / 2;
    if (!half || !pxPerSecond) return;

    root.style.setProperty('--cml-marquee-duration', half / pxPerSecond + 's');
  }

  /* ------------------------------------------------------------------- boot */

  function init(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-cml-gallery]').forEach(initGallery);
    context.querySelectorAll('[data-cml-header]').forEach(initHeader);
    context.querySelectorAll('[data-cml-buyform]').forEach(initBuyForm);
    context.querySelectorAll('[data-cml-marquee]').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor: sections are replaced in place, so re-run on the section that changed.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
